//@ts-ignore
export const pluck = key => array => Array.from(new Set(array.map(obj => obj[key])));